export const NO_VALUE = "-";
export const NA = "n/a";
